const { transformEnumToObject } = require('@/tools');
const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');

module.exports = (s) => {
  return [
    {
      name: 'ID',
      value: 'id',
    },
    {
      name: '媒体标签ID',
      value: 'channel_label_id',
    },
    {
      name: '广告商',
      format: ({ advertiser }) => {
        const channel_interface_map = transformEnumToObject(CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT);
        return channel_interface_map[advertiser];
      },
    },
    {
      name: '广告主',
      value: 'advertiser_id',
    },
    {
      name: '标签名称',
      value: 'name',
    },
    {
      name: '操作',
      width: 120,
      format: (row) => {
        const h = s.$createElement;
        const ele = h('div',
          null, [
            h('el-link',
              {
                props: {
                  type: 'primary',
                  underline: false,
                },
                on: {
                  click: () => {
                    s.onBind(row);
                  },
                },
              },
              '绑定'
            ),
            h('el-link',
              {
                class: 'ml-10',
                props: {
                  type: 'primary',
                  underline: false,
                },
                on: {
                  click: () => {
                    s.onUnbind(row);
                  },
                },
              },
              '解绑',
            ),
            h('el-link',
              {
                class: 'ml-10',
                props: {
                  type: 'danger',
                  underline: false,
                },
                on: {
                  click: () => {
                    s.onDel(row);
                  },
                },
              },
              '删除'
            ),
          ]
        );
        return ele;
      },
    },
  ];
};
